// 3rd party
import * as React from 'react';

// Shared UI
import { useLocalization } from '@shared-ui/localization-context';

// UI Toolkit
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkHeading, UitkParagraph } from 'uitk-react-text';

// Components
import { WidgetCodeGuideLink } from 'components/shared/widget';

// Models
import { Product } from 'models';

interface WidgetCodeProps {
  children: React.ReactNode;
  product: Product;
}

const WidgetCode = React.memo(
  // tslint:disable-next-line:no-shadowed-variable
  function WidgetCode(props: WidgetCodeProps): JSX.Element {
    const { children, product } = props;

    const l10n = useLocalization();

    return (
      <section>
        <UitkHeading tag="h2" size={4}>
          {/*<LocalizedText message="product.widget.code.title" />*/}
          {'Get the code'}
        </UitkHeading>

        <UitkParagraph size={1}>
          {/*<LocalizedText message="product.widget.code.instructions" />*/}
          {
            'To embed this on your website, copy the code below. To learn more, read the implementation guide linked below.'
          }
        </UitkParagraph>

        <UitkParagraph size={1}>
          <WidgetCodeGuideLink product={product} />
        </UitkParagraph>

        <UitkSpacing margin={{ blockstart: 'four' }}>{children}</UitkSpacing>
      </section>
    );
  },
);

export { WidgetCode };
